export enum ProductCompanyTypeEnum {
  // 自社コード
  OWN_COMPANY = '01',
  // 他社コード
  OTHER_COMPANY = '02',
}
